import { TableSupplierTransaction } from './components'

export const TabSupplierTransaction = () => {
  return <TableSupplierTransaction />
}
